import { composeIO } from 'react-compose-io'
import { resumoInadimplenciaIO } from './ResumoInadimplencia.IO'
import { ResumoInadimplenciaView } from './ResumoInadimplencia.View'

export const ResumoInadimplencia = composeIO(ResumoInadimplenciaView, resumoInadimplenciaIO)
